import { Link } from "react-router-dom";
import { footerLinks, site } from "@/config/site";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-secondary-50">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-content mx-auto py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2">
                <span className="w-10 h-10 rounded-md bg-secondary-500 text-secondary-950 flex items-center justify-center">
                  <i className="ri-water-flash-line text-xl"></i>
                </span>
                <span className="font-heading font-black text-xl">{site.name}</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-secondary-100/80 max-w-sm">
                {site.slogan} 我们关注值得被认真对待的娱乐话题，每天为你整理一份干净、好读的新瓜清单。
              </p>
              <a
                href={`mailto:${site.email}`}
                className="mt-5 inline-flex items-center gap-2 text-sm text-secondary-50 hover:text-accent-300 transition-colors"
              >
                <i className="ri-mail-line"></i>
                {site.email}
              </a>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-medium text-accent-300 tracking-wide">
                  {group.title}
                </h4>
                <ul className="mt-4 space-y-2.5">
                  {group.items.map((item) => (
                    <li key={item.label}>
                      <Link
                        to={item.path}
                        className="text-sm text-secondary-100/80 hover:text-secondary-50 transition-colors"
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-secondary-700/60">
          <div className="max-w-content mx-auto py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-100/70">
            <p>© 2026 {site.name} · 本站内容为娱乐资讯整理，仅供阅读交流。</p>
            <p className="flex items-center gap-2">
              <i className="ri-refresh-line"></i>
              内容最后更新于 {site.updatedAt}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}